import { useRetainerUsageBalance } from "@features/services-feature/contracts/useRetainerUsageBalance";
import { useRecurringServiceUsageBalance } from "@features/services-feature/contracts/useRecurringServiceUsageBalance";
import { UsageBalanceHook } from "./types";
import { BillingTypes } from "shared-ui/src/features/contracts-feature/constants";

// Registry: maps billingType string to the correct hook
export const usageBalanceHookRegistry: Record<string, UsageBalanceHook> = {
  [BillingTypes.retainer]: (contractId) => useRetainerUsageBalance(contractId),
  [BillingTypes.recurringService]: (contractId) =>
    useRecurringServiceUsageBalance(contractId),
  // Add more as needed
};
